module.exports = { "default": require("core-js/library/fn/symbol"), __esModule: true };


/*****************
 ** WEBPACK FOOTER
 ** ../~/rc-animate/~/babel-runtime/core-js/symbol.js
 ** module id = 1331
 ** module chunks = 3
 **/